import api from './api';
import axios from 'axios';

const getFilenameFromDisposition = (headers) => {
  const cd = headers['content-disposition'];
  if (!cd) return null;
  const match = cd.match(/filename="?([^";\n]+)"?/);
  return match ? match[1].trim() : null;
};

const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

const fileService = {
  // Téléchargement d'un fichier STL
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    // Utiliser axios directement pour les uploads de fichiers
    const token = localStorage.getItem('token');
    const response = await axios.post(`${api.defaults.baseURL}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  },
  
  // Récupération des métadonnées d'un fichier
  getFileById: async (fileId) => {
    return await api.get(`/files/${fileId}`);
  },
  
  // Récupération de l'URL de téléchargement d'un fichier
  //getDownloadUrl: (fileId) => {
  //  return `${api.defaults.baseURL}/files/${fileId}/download`;
  //},
  getDownloadUrl: (fileId) => {
    const token = localStorage.getItem('token');
    // Retourne l'URL complète avec le token dans un paramètre
    // Note: Cette approche n'est pas aussi sécurisée que les en-têtes mais peut fonctionner
    // pour les cas où vous devez charger le fichier via une balise <img> ou autre élément HTML
    return `${api.defaults.baseURL}/files/${fileId}/download?token=${token}`;
  },

  getPreviewUrl: (fileId) => {
    const token = localStorage.getItem('token');
    return `${api.defaults.baseURL}/files/${fileId}/download?token=${token}&preview=true`;
  },

  // Téléchargement d'un fichier — retourne { blob, filename }
  downloadFile: async (fileId) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${api.defaults.baseURL}/files/${fileId}/download`, {
      headers: { 'Authorization': `Bearer ${token}` },
      responseType: 'blob'
    });
    return {
      blob: response.data,
      filename: getFilenameFromDisposition(response.headers)
    };
  },

  // Téléchargement de tous les fichiers d'une soumission en ZIP
  downloadSubmissionFiles: async (submissionId, submissionName, onProgress) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${api.defaults.baseURL}/submissions/${submissionId}/download`, {
      headers: { 'Authorization': `Bearer ${token}` },
      responseType: 'blob',
      onDownloadProgress: onProgress ? (e) => onProgress(e.loaded, e.total || 0) : undefined
    });
    const filename = getFilenameFromDisposition(response.headers)
      || `${submissionName || 'soumission-' + submissionId}.zip`;
    triggerDownload(response.data, filename);
  },

  // Téléchargement de tous les fichiers d'une commande en ZIP
  downloadOrderFiles: async (orderId, onProgress) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${api.defaults.baseURL}/orders/${orderId}/download`, {
      headers: { 'Authorization': `Bearer ${token}` },
      responseType: 'blob',
      onDownloadProgress: onProgress ? (e) => onProgress(e.loaded, e.total || 0) : undefined
    });
    const filename = getFilenameFromDisposition(response.headers) || `commande-${orderId}.zip`;
    triggerDownload(response.data, filename);
  },

  // Téléchargement individuel de tous les fichiers (sans archive)
  downloadAllIndividually: async (files) => {
    const token = localStorage.getItem('token');
    for (const file of files) {
      const response = await axios.get(`${api.defaults.baseURL}/files/${file.id}/download`, {
        headers: { 'Authorization': `Bearer ${token}` },
        responseType: 'blob'
      });
      const filename = getFilenameFromDisposition(response.headers) || file.filename;
      triggerDownload(response.data, filename);
      await new Promise(r => setTimeout(r, 300));
    }
  },

  // Suppression d'un fichier (admin uniquement)
  deleteFile: async (fileId) => {
    return await api.delete(`/files/${fileId}`);
  }
};

export default fileService;